import { NgModule } from '@angular/core';
import { Title, BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { LoginService } from './services/login-service/login-service';
import { ProjectService } from './services/project-service/project-service';
import { DataSharingService } from './services/login-service/data-sharing-service';

import { ProjectStore } from './services/stores/project.store';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppCollapseNavbarModule } from './components/collapse-navbar/collapse-navbar.module';
import { MainViewComponent } from './components/main-view/main-view.component';

import { routingComponents, appRouting, routingProviders } from './app.routing';

import { AUTH_ENABLED } from './app.tokens';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [
    AppComponent,
    routingComponents,
    MainViewComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    appRouting,
    AppCollapseNavbarModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatCardModule
  ],
  providers: [
    routingProviders,
    LoginService,
    ProjectService,
    ProjectStore,
    DataSharingService,
    Title,
    {provide: AUTH_ENABLED, useValue: true}
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
